import React, { useState, useEffect, useMemo } from "react";
import { CiCalendar } from "react-icons/ci";
import { IoCloseCircleOutline } from "react-icons/io5";
import { IoCloudDownloadOutline } from "react-icons/io5";
import { jobsEndpoint } from "../constants";

const optionsSetReports = [
  { title: "Hiring Trends" },
  { title: "Recruiter  Performance" },
  { title: "Diversity Metrics" },
];
const optionsRecruitment = [
  { title: "Time to Hire" },
  { title: "Time to Fill" },
  { title: "Offer acceptance rate" },
  { title: "Candidate Drop-Off Rate" },
];
const optionsRecruiter = [
  { title: "Sourcing Effectiveness" },
  { title: "Recruiter Performance " },
];

const Report = () => {
  const [jobs, setJobs] = useState([]);
  const token = localStorage.getItem("token");

  const [searchTerm, setSearchTerm] = useState("");
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [expandedJobs, setExpandedJobs] = useState(new Set());
  const [dropdownOpen, setDropdownOpen] = useState(null);
  const [filterStatus, setFilterStatus] = useState("all");
  const [showGenerateReport, setShowGenerateReport] = useState(false);
  const [reports, setReports] = useState([]);
  const [reportData, setReportData] = useState(null);
  const [notificationSettings, setNotificationSettings] = useState({
    HiringTrends: false,
    RecruiterPerformanceSetReport: false,
    DiversityMetrics: false,
    TimeToHire: false,
    TimeToFill: false,
    OfferAcceptanceRate: false,
    CandidateDropOffRate: false,
    SourcingEffectiveness: false,
    RecruiterPerformance: false,
  });

  const navigate = (path) => console.log(`Navigate to: ${path}`);

  const downloadFile = (url, filename) => {
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleGenerateReport = async () => {
    const attributes = Object.keys(notificationSettings).filter(key => notificationSettings[key]);
    try {
      const response = await fetch(jobsEndpoint + 'reports/generate/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Token ${token}`
        },
        body: JSON.stringify({ attributes })
      });
      const data = await response.json();
      setReportData(data);
      setShowGenerateReport(false);
      // Refresh reports list after generating new report
      fetchReports();
    } catch (error) {
      console.error('Error generating report:', error);
      setError('Failed to generate report.');
    }
  };

  const fetchReports = async () => {
    try {
      const response = await fetch(jobsEndpoint + 'reports/list/', {
        headers: {
          'Authorization': `Token ${token}`
        }
      });
      const data = await response.json();
      setReports(data);
    } catch (error) {
      console.error('Error fetching reports:', error);
    }
  };

  useEffect(() => {
    const fetchJobsWithApplicants = async () => {
      try {
        setLoading(true);
        
        const mockJobs = [
          {
            id: 1,
            title: "Senior React Developer",
            company: "TechCorp Inc",
            location: "London, UK",
            created_at: "2024-01-15T10:00:00Z",
            updated_at: "2024-01-20T15:30:00Z",
            applicants: [
              {
                id: 101,
                application_status: "pending",
                job_title: "Senior React Developer",
                company_name: "TechCorp Inc",
                date_updated: "2024-01-18T14:20:00Z",
                cv_files: [
                  { id: 1, name: "john_doe_cv.pdf", url: "/files/cv1.pdf", size: 1048576 }
                ],
                extra_files: [
                  { id: 2, name: "portfolio.pdf", url: "/files/portfolio1.pdf", size: 2097152 }
                ],
                cv_count: 1,
                extra_files_count: 1
              },
              {
                id: 102,
                application_status: "approved",
                job_title: "Senior React Developer",
                company_name: "TechCorp Inc",
                date_updated: "2024-01-19T09:15:00Z",
                cv_files: [
                  { id: 3, name: "jane_smith_cv.pdf", url: "/files/cv2.pdf", size: 1572864 }
                ],
                extra_files: [],
                cv_count: 1,
                extra_files_count: 0
              }
            ]
          },
          {
            id: 2,
            title: "Full Stack Developer",
            company: "StartupXYZ",
            location: "Manchester, UK",
            created_at: "2024-01-10T08:00:00Z",
            updated_at: "2024-01-22T11:45:00Z",
            applicants: [
              {
                id: 103,
                application_status: "rejected",
                job_title: "Full Stack Developer",
                company_name: "StartupXYZ",
                date_updated: "2024-01-21T16:30:00Z",
                cv_files: [
                  { id: 4, name: "bob_wilson_cv.pdf", url: "/files/cv3.pdf", size: 1310720 }
                ],
                extra_files: [
                  { id: 5, name: "certifications.pdf", url: "/files/cert1.pdf", size: 524288 },
                  { id: 6, name: "references.pdf", url: "/files/ref1.pdf", size: 786432 }
                ],
                cv_count: 1,
                extra_files_count: 2
              }
            ]
          },
          {
            id: 3,
            title: "UI/UX Designer",
            company: "DesignStudio",
            location: "Birmingham, UK",
            created_at: "2024-01-25T12:00:00Z",
            updated_at: "2024-01-25T12:00:00Z",
            applicants: []
          }
        ];

        // Calculate stats for each job
        const jobsWithStats = mockJobs.map(job => ({
          ...job,
          total_applicants: job.applicants.length,
          pending_applicants: job.applicants.filter(a => a.application_status?.toLowerCase() === 'pending').length,
          approved_applicants: job.applicants.filter(a => a.application_status?.toLowerCase() === 'approved').length,
          rejected_applicants: job.applicants.filter(a => a.application_status?.toLowerCase() === 'rejected').length,
        }));

        setJobs(jobsWithStats);
      } catch (err) {
        setError("Failed to load jobs and applicants.");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchJobsWithApplicants();
  }, [token]);

  useEffect(() => {
    fetchReports();
  }, [token, reportData]);

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  const toggleJobExpansion = (jobId) => {
    const newExpanded = new Set(expandedJobs);
    if (newExpanded.has(jobId)) {
      newExpanded.delete(jobId);
    } else {
      newExpanded.add(jobId);
    }
    setExpandedJobs(newExpanded);
  };

  const filteredJobs = useMemo(() => {
    let result = [...jobs];

    if (searchTerm) {
      const searchLower = searchTerm.toLowerCase();
      result = result.filter((job) => {
        // Search in job fields
        const jobMatch = job.title?.toLowerCase().includes(searchLower) ||
                        job.company?.toLowerCase().includes(searchLower) ||
                        job.location?.toLowerCase().includes(searchLower);
        
        // Search in applicant fields
        const applicantMatch = job.applicants?.some(applicant =>
          applicant.application_status?.toLowerCase().includes(searchLower) ||
          applicant.job_title?.toLowerCase().includes(searchLower) ||
          applicant.company_name?.toLowerCase().includes(searchLower)
        );

        return jobMatch || applicantMatch;
      });
    }

    // Filter by status
    if (filterStatus !== "all") {
      result = result.filter(job => {
        switch (filterStatus) {
          case "has_applicants":
            return job.total_applicants > 0;
          case "no_applicants":
            return job.total_applicants === 0;
          case "pending":
            return job.pending_applicants > 0;
          case "approved":
            return job.approved_applicants > 0;
          case "rejected":
            return job.rejected_applicants > 0;
          default:
            return true;
        }
      });
    }

    if (sortConfig.key) {
      result.sort((a, b) => {
        let aVal = a[sortConfig.key];
        let bVal = b[sortConfig.key];
        
        if (sortConfig.key === 'created_at' || sortConfig.key === 'updated_at') {
          aVal = new Date(aVal);
          bVal = new Date(bVal);
        }
        
        if (aVal < bVal) {
          return sortConfig.direction === "asc" ? -1 : 1;
        }
        if (aVal > bVal) {
          return sortConfig.direction === "asc" ? 1 : -1;
        }
        return 0;
      });
    }

    return result;
  }, [jobs, searchTerm, sortConfig, filterStatus]);

  const toggleDropdown = (applicantId) => {
    setDropdownOpen(dropdownOpen === applicantId ? null : applicantId);
  };

  useEffect(() => {
    const handleClickOutside = () => setDropdownOpen(null);
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  const getStatusBadgeColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'approved':
        return 'bg-green-100 text-green-600 border-green-400';
      case 'pending':
        return 'bg-yellow-100 text-yellow-600 border-yellow-400';
      case 'rejected':
        return 'bg-red-100 text-red-600 border-red-400';
      default:
        return 'bg-gray-100 text-gray-600 border-gray-400';
    }
  };

  const renderFileDownloadDropdown = (applicant) => {
    const cvFiles = applicant.cv_files || [];
    const extraFiles = applicant.extra_files || [];
    
    return (
      <div className="absolute right-0 mt-2 w-64 bg-white rounded-md shadow-lg border border-gray-200 z-50 max-h-96 overflow-y-auto">
        <div className="py-1">
          {cvFiles.length > 0 && (
            <>
              <div className="px-4 py-2 text-xs font-semibold text-gray-500 bg-gray-50 border-b">
                CV Files ({cvFiles.length})
              </div>
              {cvFiles.map((file) => (
                <button
                  key={`cv-${file.id}`}
                  onClick={() => downloadFile(file.url, file.name)}
                  className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 truncate"
                  title={file.name}
                >
                  📄 {file.name}
                </button>
              ))}
            </>
          )}
          
          {extraFiles.length > 0 && (
            <>
              <div className="px-4 py-2 text-xs font-semibold text-gray-500 bg-gray-50 border-b">
                Extra Files ({extraFiles.length})
              </div>
              {extraFiles.map((file) => (
                <button
                  key={`extra-${file.id}`}
                  onClick={() => downloadFile(file.url, file.name)}
                  className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 truncate"
                  title={file.name}
                >
                  📎 {file.name}
                </button>
              ))}
            </>
          )}
          
          <button
            onClick={() => navigate(`/applicant_details/${applicant.id}`)}
            className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 border-t"
          >
            👁️ View Details
          </button>
        </div>
      </div>
    );
  };

  const totalApplicants = jobs.reduce((sum, job) => sum + job.total_applicants, 0);
  const totalPending = jobs.reduce((sum, job) => sum + job.pending_applicants, 0);
  const totalApproved = jobs.reduce((sum, job) => sum + job.approved_applicants, 0);

  return (
    <div className="lg:p-8">
      {/* Header Section */}
      <div className="mb-8">
        <div className="flex justify-between items-center">
          <div>
            <h1 className="text-2xl font-semibold text-gray-900">Reports</h1>
            <p className="mt-1 text-sm text-gray-600">
              Here is a complete list of all Reports.
            </p>
          </div>
          <button
            className="bg-[#19BFB7] hover:bg-[#17ACA5] text-white font-semibold py-2 px-6 rounded-lg shadow transition"
            onClick={() => setShowGenerateReport(true)}
          >
            Generate Report
          </button>
        </div>
      </div>

      {/* Generate Report Modal */}
      {showGenerateReport && (
        <div
          className="fixed inset-0 bg-black/50 z-[999] flex items-center justify-center"
          onClick={() => setShowGenerateReport(false)}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="bg-white rounded-lg shadow-lg p-6 w-2/6 max-h-[90vh] overflow-y-auto flex flex-col items-start justify-start gap-4 z-[1000]"
          >
            <div className="flex items-center justify-between w-full">
              <div className="p-2 bg-gray-200 rounded-full w-10 h-10 flex items-center justify-center">
                <CiCalendar className="text-black w-8 h-8" />
              </div>
              <IoCloseCircleOutline
                className="text-black w-8 h-8 cursor-pointer"
                onClick={() => setShowGenerateReport(false)}
              />
            </div>
            <div className="flex flex-col items-start justify-center gap-3 border-b border-gray-300 pb-4 w-full">
              <h2 className="text-gray-800 font-semibold">Generate Report</h2>
              <p className="text-gray-400 text-sm font-normal">
                Generate and download report
              </p>
            </div>
            <form className="w-full flex items-start gap-5 flex-col">
              <div className="w-full flex flex-col items-start gap-3">
                <div className="flex flex-col items-start w-full gap-5 border-b border-gray-300 pb-5">
                  <h2 className="text-black font-semibold text-lg">
                    Set Report Preferences
                  </h2>
                  {optionsSetReports.map((option) => {
                    const key = option.title.replace(/\s+/g, "");
                    return (
                      <div key={key} className="flex items-center w-full pb-3">
                        <h2 className="text-gray-800 text-sm font-semibold w-1/2">
                          {option.title}
                        </h2>
                        <div className="flex items-center gap-3">
                          <div
                            onClick={() =>
                              setNotificationSettings((prev) => ({
                                ...prev,
                                [key]: !prev[key],
                              }))
                            }
                            className={`w-10 h-5 rounded-full shadow-sm relative transition-colors duration-300 ease-in-out ${
                              notificationSettings[key]
                                ? "bg-[#19BFB7]"
                                : "bg-gray-100"
                            } px-[3px] cursor-pointer`}
                          >
                            <span
                              className={`rounded-full w-3 h-3 transition-transform duration-200 bg-white ${
                                notificationSettings[key]
                                  ? "translate-x-5"
                                  : "translate-x-0"
                              } shadow-sm absolute -translate-y-1/2 top-1/2`}
                            ></span>
                          </div>
                          <p className="text-gray-800 text-sm font-semibold">
                            {notificationSettings[key] ? "YES" : "NO"}
                          </p>
                        </div>
                      </div>
                    );
                  })}
                </div>
                <div className="flex flex-col items-start w-full gap-5 border-b border-gray-300 pb-5">
                  <h2 className="text-black font-semibold text-lg">
                    Recruitment Performance Metrics
                  </h2>
                  {optionsRecruitment.map((option) => {
                    const key = option.title.replace(/\s+/g, "");
                    return (
                      <div key={key} className="flex items-center w-full pb-3">
                        <h2 className="text-gray-800 text-sm font-semibold w-1/2">
                          {option.title}
                        </h2>
                        <div className="flex items-center gap-3">
                          <div
                            onClick={() =>
                              setNotificationSettings((prev) => ({
                                ...prev,
                                [key]: !prev[key],
                              }))
                            }
                            className={`w-10 h-5 rounded-full shadow-sm relative transition-colors duration-300 ease-in-out ${
                              notificationSettings[key]
                                ? "bg-[#19BFB7]"
                                : "bg-gray-100"
                            } px-[3px] cursor-pointer`}
                          >
                            <span
                              className={`rounded-full w-3 h-3 transition-transform duration-200 bg-white ${
                                notificationSettings[key]
                                  ? "translate-x-5"
                                  : "translate-x-0"
                              } shadow-sm absolute -translate-y-1/2 top-1/2`}
                            ></span>
                          </div>
                          <p className="text-gray-800 text-sm font-semibold">
                            {notificationSettings[key] ? "YES" : "NO"}
                          </p>
                        </div>
                      </div>
                    );
                  })}
                </div>
                <div className="flex flex-col items-start w-full gap-5 border-b border-gray-300 pb-5">
                  <h2 className="text-black font-semibold text-lg">
                    Recruiter & Team Efficiency
                  </h2>
                  {optionsRecruiter.map((option) => {
                    const key = option.title.replace(/\s+/g, "");
                    return (
                      <div key={key} className="flex items-center w-full pb-3">
                        <h2 className="text-gray-800 text-sm font-semibold w-1/2">
                          {option.title}
                        </h2>
                        <div className="flex items-center gap-3">
                          <div
                            onClick={() =>
                              setNotificationSettings((prev) => ({
                                ...prev,
                                [key]: !prev[key],
                              }))
                            }
                            className={`w-10 h-5 rounded-full shadow-sm relative transition-colors duration-300 ease-in-out ${
                              notificationSettings[key]
                                ? "bg-[#19BFB7]"
                                : "bg-gray-100"
                            } px-[3px] cursor-pointer`}
                          >
                            <span
                              className={`rounded-full w-3 h-3 transition-transform duration-200 bg-white ${
                                notificationSettings[key]
                                  ? "translate-x-5"
                                  : "translate-x-0"
                              } shadow-sm absolute -translate-y-1/2 top-1/2`}
                            ></span>
                          </div>
                          <p className="text-gray-800 text-sm font-semibold">
                            {notificationSettings[key] ? "YES" : "NO"}
                          </p>
                        </div>
                      </div>
                    );
                  })}
                </div>
                <button
                  type="button"
                  onClick={handleGenerateReport}
                  className="bg-[#19BFB7] hover:bg-[#17ACA5] text-white font-semibold py-2 px-6 rounded-lg shadow transition w-full"
                >
                  Generate
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Loading/Error */}
      {loading && <p className="text-gray-500">Loading reports...</p>}
      {error && <p className="text-red-500">{error}</p>}

      {/* Reports Table */}
      {!loading && !error && (
        <div className="bg-white rounded-xl border border-gray-200 mt-10">
          <div className="pt-3 px-5">
            <h3 className="text-sm font-semibold text-gray-900">
              Total Reports
            </h3>
          </div>
          <div className="flex gap-3 items-end py-4 px-5 border-b border-gray-200 rounded-t-md">
            <h3 className="text-2xl text-gray-900 font-semibold">{reports.length}</h3>
            <div className="flex items-center gap-1 text-sm text-emerald-600">
              <span>↑ 8.6%</span>
              <span className="text-gray-600 ml-1">vs last 30 days</span>
            </div>
          </div>

          <div className="">
            <div className="px-5 py-3 grid md:grid-cols-5 sm:grid-cols-3 grid-cols-2 border-b border-gray-200">
              <div className="flex gap-3 items-center md:col-span-3 sm:col-span-2">
                <input
                  type="checkbox"
                  className="rounded border-gray-300 text-sm cursor-pointer"
                />
                <h5 className="text-gray-500 font-semibold">Report</h5>
              </div>

              <div className="md:col-span-2 col-span-1">
                <h5 className="text-gray-500 font-semibold sm:block hidden md:text-sm text-xs">
                  Date generated
                </h5>
              </div>
            </div>

            {reports.length > 0 ? (
              reports.map((report) => (
                <div
                  key={report.id}
                  className="grid md:grid-cols-5 sm:grid-cols-3 grid-cols-2 items-center p-4 border-b border-gray-200"
                >
                  <div className="flex items-center gap-3 md:col-span-3 sm:col-span-2 col-span-1">
                    <input
                      type="checkbox"
                      className="rounded border-gray-300 sm:block hidden"
                    />
                    <div className="w-10 h-10 rounded-full bg-[#19bfb7] flex items-center justify-center text-white font-semibold md:block hidden">
                      {report.name ? report.name.charAt(0) : 'R'}
                    </div>

                    <p className="font-medium text-gray-900 sm:text-lg text-sm">
                      {report.name || `Report #${report.id}`}
                    </p>
                  </div>
                  <div className="flex justify-between items-center md:col-span-2 col-span-1">
                    <p className="font-medium md:text-sm text-xs text-gray-500">
                      {new Date(report.created_at || Date.now()).toLocaleDateString('en-US', {
                        month: 'short',
                        day: 'numeric',
                        year: 'numeric'
                      })}
                    </p>

                    <span 
                      className="text-[#009C97] text-sm font-semibold flex items-center gap-2 cursor-pointer" 
                      onClick={() => report.url && window.open(report.url, '_blank')}
                    >
                      <IoCloudDownloadOutline />
                      Download
                    </span>
                  </div>
                </div>
              ))
            ) : (
              <div className="p-8 text-center text-gray-500">
                <p>No reports generated yet. Click "Generate Report" to create your first report.</p>
              </div>
            )}

            <div className="px-5 py-4 flex items-center justify-between bg-gray-50">
              <div>
                <p className="text-md font-semibold text-gray-900">
                  Page <span>1</span> of <span>1</span>
                </p>
              </div>
              <div className="flex gap-5 items-center">
                <button className="text-sm bg-white border border-gray-300 text-gray-900 py-2 px-3 rounded-md cursor-pointer">
                  Previous
                </button>
                <button className="text-sm bg-white text-gray-900 py-2 px-3 border border-gray-300 rounded-md cursor-pointer">
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Report;